module.exports = __webpack_public_path__ + "img/login-panel-bg.86876957.jpg";